<template>
	<div class="sticky-summary">
		<div class="flex xs-12 mb2 xs-middle" slot="headline">
			<div class="fs5 lh125 fw7 c1">{{ $t("benefit_claims") }}</div>
		</div>
		<j-card class="flex wrap bg5 p4">
			<div class="flex wrap xs-6 xs-middle ta1 fs8 fw7">
				<div>{{ data.formattedApprovedAmount }}</div>
				<div class="xs-12 c6 fs3 fw7">{{ $t("total_approved_amount") }}</div>
			</div>
			<div class="xs-6">
				<div class="ta1 lh125">
					<span class="c6 fs3 fw7">{{ $t("total_billed_amount") }}:</span>
					{{ data.formattedBilledAmount }}
				</div>
				<div class="ta1 lh125">
					<span class="c6 fs3 fw7">{{ $t("total_approved_amount") }}:</span>
					{{ data.formattedApprovedAmount }}
				</div>
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"

export default {
	components: {
		JCard
	},
	props: {
		data: {
			type: Object,
			default: () => ({
				formattedApprovedAmount: null,
				formattedBilledAmount: null
			})
		}
	}
}
</script>
<style scoped>
@media (min-width: 720px) {
	.sticky-summary {
		position: sticky;
		top: 22px;
		z-index: 10;
	}
}
</style>
